import * as moment from 'moment';
import {Set} from 'immutable';
import {IStationApi} from '../../api/station-api.service';
import {IStation, IForecastModel, IForecastModelParams, IForecastType, IForecastModelDataInput} from '../../api/api.types';
import {IStationSelectorService} from '../selector/selector.service';
import {IForecastingService} from './forecast-model.service';
import {IFilterFilter} from 'angular';
import {StateParams} from 'angular-ui-router';
import {IStationDetailsStateParams} from '../details/details.controller';
import IOrganizationApi from '../../api/organization-api.service';
import {IImomoErrorService} from '../../error/error.service';
import {StateService} from 'angular-ui-router';
import {PredictionDateDialog} from './prediction-date-dialog.controller';

const predictionDateDialogTemplate = require<string>(
    './prediction-date-dialog.html');

export default class StationForecastingController {
  static $inject = ['stationApi', 'stationSelectorService', 'forecastingService', '$filter', 
                    '$stateParams', 'organizationApi', '$window', 'imomoErrorService', '$mdDialog', '$translate', '$q', '$state', '$timeout', '$rootScope'];

  private forecastModels: IForecastModel[] = [];
  private newForecastModelName: string;
  private selectedForecastModel: IForecastModel;
  private selectedForecastModelCached: IForecastModel;
  private currentForecastModelParams: any[];
  private selectedForecastType: IForecastType;
  private forecastTypes: IForecastType[];
  private forecastMethods: string[];
  private forecastMethodParams: any[];
  private forecastModelParams: any;
  private filter: IFilterFilter;
  private stationId: number;
  private isLoading: boolean;
  private station: IStation;
  private isEditable: boolean;
  private isNew: boolean;
  private selectedForecastModelFrequency: string;
  private isForecastTypeDataExpanded: boolean = false;
  // private featureDataQmSearchText: string;
  // private featureDataPmSearchText: string;
  // private featureDataTmSearchText: string;
  // private featureDataSmSearchText: string;

  constructor(
    private stationApi:IStationApi, 
    private stationSelectorService: IStationSelectorService,
    private forecastingService: IForecastingService,
    $filter: ng.IFilterService,
    private $stateParams:IStationDetailsStateParams,
    private organizationApi: IOrganizationApi,
    private $window: ng.IWindowService,
    private imomoErrorService: IImomoErrorService,
    private $mdDialog: ng.material.IDialogService,
    private $translate:ng.translate.ITranslateService,
    private $q:ng.IQService,
    private $state:StateService,
    private $timeout: ng.ITimeoutService,
    private $rootScope: ng.IRootScopeService
  ) {
    this.filter = $filter('filter');
    this.forecastMethodParams = null;
    this.stationId = Number.parseInt($stateParams.stationId);
    const currentOrgId = Number.parseInt(this.$window.localStorage.getItem('currentOrgId'));

    this.isLoading = true;

    this.$q.all([
      this.organizationApi.getForecastTypes(currentOrgId),
      this.stationApi.getForecastModels(this.stationId),
      this.stationApi.getDischargeStation({stationId: this.stationId})
    ]).then(([forecastTypes, forecastModels, station]) => {
      this.forecastTypes = forecastTypes;
      this.forecastModels = forecastModels;
      this.station = station;
      this.forecastMethods = this.forecastingService.getForecastModelMethods();
      this.forecastModelParams = this.forecastingService.getForecastModelParameters();
      this.$rootScope.$broadcast('STATION_LOADED', station);
      if (this.forecastModels && this.forecastModels.length) {
        this.selectedForecastModel = this.forecastModels[0];
        
        this.onMethodChange();
        this.onForecastTypeChange();
      }
    })
    .finally(() => {
      this.isLoading = false;
    })
  }

  addToForecastModelList() {
    
    let isNameDuplicate: boolean; 
    let defaultDataInput = {
        siteId: this.station.id,
        siteName: this.station.siteName,
        siteType: this.station.siteType,
        siteCode: this.station.siteCode,
        dataValueTypes: [
          {
            type: 'discharge',
            laglength: 1
          }]
    }
    let defaultForecastModel: IForecastModel = {
      name: this.newForecastModelName,
      forecastTypeId: undefined,
      method: undefined,
      dataInputs: [defaultDataInput],
      methodParameters: {
        fit_intercept: undefined,
        alpha: undefined,
        n_estimators: undefined,
        random_state: undefined
      },
      modelParameters: {
        multimodel: undefined,
        earliestMonth: undefined,
        nModel: undefined,
        maxFeatures: undefined
      }
    }

    this.forecastModels.forEach((model) => {
      if (model.name === this.newForecastModelName) {
        isNameDuplicate = true;
      }
    });

    if (!isNameDuplicate) {
      this.forecastModels.push(defaultForecastModel)
      this.selectedForecastModel = this.forecastModels[this.forecastModels.length - 1];
      this.newForecastModelName = null;
      this.isNew = true;
    }

    this.selectedForecastType = null;
  }

  removeForecastModel(forecastModelIndex?: number) {
    const self = this;
    if(!forecastModelIndex) {
      forecastModelIndex = this.forecastModels.indexOf(this.selectedForecastModel);
    }
    let confirm = this.$mdDialog.confirm()
        .title(this.$translate.instant('DELETE_FORECAST_MODEL'))
        .textContent(this.$translate.instant('DELETE_CONFIRMATION', {item: this.forecastModels[forecastModelIndex].name}))
        //.targetEvent($event)
        .ok(this.$translate.instant('DELETE'))
        .cancel(this.$translate.instant('CANCEL'));

    this.$mdDialog.show(confirm).then(() => {
      if (this.forecastModels[forecastModelIndex].id) {
        this.stationApi.deleteForecastModel(this.stationId, this.forecastModels[forecastModelIndex].id)
          .then(() => {
            removeModelFromList();
          })
          .finally(() => {
            this.isEditable = false;
            this.isNew = false;
          });
      } else {
        removeModelFromList();
        this.isEditable = false;
        this.isNew = false;
      }
      
    });

    function removeModelFromList() {
      self.forecastModels.splice(forecastModelIndex, 1);

      if (self.forecastModels.length) {
        self.selectedForecastModel = self.forecastModels[self.forecastModels.length - 1];
      } else {
        self.selectedForecastModel = null;
      }
    }
  }

  onForecastModelRadioChange() {
    this.isNew = false;
    this.onForecastTypeChange();
  }

  onSelectedStationsChange(stations: Set<IStation>) {
    if (this.selectedForecastModel) {
      this.selectedForecastModel.dataInputs = stations.toArray();
    }
  }

  onHighlightedStationChange(station: IStation) {
    //console.log(station);
  }


  onForecastTypeChange() {
    // let params:any = {};
    if (this.selectedForecastModel && 
      this.forecastTypes && 
      this.forecastModelParams
    ) {

      this.selectedForecastType = _.filter(this.forecastTypes,(forecastType: IForecastType) => {
          return this.selectedForecastModel.forecastTypeId == forecastType.id
        })[0];

      const forecastTypeFrequency = this.selectedForecastType.frequency;

      this.selectedForecastModelFrequency = forecastTypeFrequency;
      this.currentForecastModelParams = 
        this.forecastModelParams[forecastTypeFrequency].params;

      if (!this.selectedForecastModel.id) {
        this.isNew = true;
      }

      this.refreshTrainingInfo();
    }

    // this.currentForecastModelParams.forEach((param) => {
    //   params[param.name] = param.default;
    // });

    // this.selectedForecastModel.parameters = params
  }

  onMethodChange() {
    this.selectedForecastModel.methodParameters = {
      fit_intercept: undefined,
      alpha: undefined,
      n_estimators: undefined,
      random_state: undefined
    }
    this.forecastMethodParams = 
      this.forecastingService.getForecastModelMethodParameters(this.selectedForecastModel.method)[0];
  }

  onTrainModelClick() {
    this.isLoading = true;
    this.stationApi.trainForecastModel(this.stationId, this.selectedForecastModel.id)
      .then((forecastModel) => {
        this.selectedForecastModel.training = forecastModel.training;
        this.selectedForecastModelCached.training = forecastModel.training;
        this.refreshTrainingInfo();
        this.isLoading = false;
      })
      .catch((error) => {
        this.imomoErrorService.showErrorDetailsDialog(error.data.details);
        this.isLoading = false;
      });
  }

  onCancelModelTrainingClick() {
    let confirm = this.$mdDialog.confirm()
        .title(this.$translate.instant('CANCEL_MODEL_TRAINING'))
        .textContent(this.$translate.instant('CANCEL_MODEL_TRAINING_CONFIRMATION'))
        //.targetEvent($event)
        .ok(this.$translate.instant('YES'))
        .cancel(this.$translate.instant('NO'));

    this.$mdDialog.show(confirm).then(() => {
      this.isLoading = true;
      this.stationApi.cancelForecastModelTraining(this.stationId, this.selectedForecastModel.id)
        .then((forecastModel) => {
          this.selectedForecastModel.training = forecastModel.training;
          this.selectedForecastModelCached.training = forecastModel.training;
          this.isLoading = false;
        })
        .catch((error) => {
          this.imomoErrorService.showErrorDetailsDialog(error.data.details);
          this.isLoading = false;
        });
      });
  }

  onSubmitModelClick() {
    this.isLoading = true;
    this.selectedForecastModel.dataInputs = this.formatDataInputs();
    this.stationApi.saveForecastModel(this.stationId, this.selectedForecastModel)
      .then((forecastModel) => {
        this.selectedForecastModel.id = forecastModel.id;
        this.forecastModels = this.forecastModels.map(model=>{
          if (model.id === forecastModel.id) {
            return forecastModel;
          }
          return model;
        })
        this.isLoading = false;
        this.isNew = false;
        this.isEditable = false;
      })
      .catch((error) => {
        this.imomoErrorService.showErrorDetailsDialog(error.data.details);
        this.isLoading = false;
      });
  }

  formatDataInputs() { 
    return _.map(this.selectedForecastModel.dataInputs, (dataInput) => {
      let formattedDataInput: IForecastModelDataInput = {
        siteId: (<IStation>dataInput).id || (<IForecastModelDataInput>dataInput).siteId,
        siteName: dataInput.siteName,
        siteType: dataInput.siteType,
        siteCode: dataInput.siteCode,
        dataValueTypes: _.map(dataInput.dataValueTypes, (dataValueType: {type:string, laglength: number}) => {
          if (this.selectedForecastModelFrequency === 'seasonal') { 
            delete dataValueType.laglength;
            return dataValueType;
          }

          return dataValueType;
        })
      }
      return formattedDataInput;
    })
  }

  onEditClicked($event: MouseEvent) {
    this.isEditable = true;
    this.selectedForecastModelCached = angular.copy(this.selectedForecastModel);
    this.forecastModels = angular.copy(this.forecastModels);
  }

  onCancelClick($event: MouseEvent) {
    this.isEditable = false;
    this.selectedForecastModel = this.selectedForecastModelCached;
  }

  refreshTrainingInfo() {
     this.stationApi.getForecastModel(this.stationId, this.selectedForecastModel.id)
       .then((forecastModel) => {
         this.selectedForecastModel.training = forecastModel.training;

         if (!this.selectedForecastModel.training.reportPdfUrl && this.selectedForecastModel.training.status !== 'error') {
           this.$timeout(() => {
             this.refreshTrainingInfo();
           }, 500)
           
         }
       })
  }

  onGeneratePredictionClick($event: MouseEvent) {
    
    this.$mdDialog.show({
      targetEvent: $event,
      template: predictionDateDialogTemplate,
      controller: PredictionDateDialog,
      bindToController: true,
      controllerAs: '$ctrl',
    })
    .then((predictionDate: Date) => { this.isLoading = true;
      this.stationApi.makeForecastPrediction(this.stationId, this.selectedForecastModel.id, predictionDate)
        .then(() => {
          this.isLoading = false;
          this.$state.go('forecasting');
        })
        .catch((error) => {
          this.imomoErrorService.showErrorDetailsDialog(error.data.details);
          this.isLoading = false;
        })
    });
  }

  // getMatchedStations(searchText: string) {
  //   return this.stationApi.getDischargeStations()
  //     .then(stations => {
  //       return this.filter(stations, searchText);
  //     });
  // }
}



/** WEBPACK FOOTER **
 ** ./app/station/forecast-model/forecast-model.controller.ts
 **/